/* eslint-disable no-param-reassign */
import * as urlUtil from '@tencent/vft-common/url';
import atom from '@tencent/vft-atom';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import { getSearchObj, getUrlParam } from '@tencent/magic-ui-util';
import cookie from '@tencent/vft-common/cookie';
import login from '@tencent/vft-common/login';
import generateFormConfig from './formConfig';
import tvHandler from './tvhandler';
import qqsportsHandler from './qqsports-handler';
import mqbHandler from './mqb-handler';
import qqnewsHandler from './qqnews-handler';
import weishiHandler from './weishi-handler';
import qqmusicHandler from './qqmusic-handler';
import sportsHandler from './sports-handler';
import yybHandler from './yyb-handler';
import tenvideoPcHandler from './tenvideopc-handler';

let magicUiApp;

const getPageConfig = () => {
  if (!magicUiApp) return {};
  return magicUiApp.pageConfig || {};
};

const openInApp = async (schemaUrl) => {
  // 参数已在之前添加，不需要再传入第二个参数true来检查账号一致性
  accountCheck.openApp(schemaUrl, false);
};

const fixUrl = url => (url.startsWith('//') ? location.protocol + url : url);

const decodeObj = obj => Object.keys(obj).reduce((newObj, key) => ({
  ...newObj,
  [key]: decodeURIComponent(obj[key]),
}), {});

const openWechat = () => {
  const { isBaseApp, isWeChat, isWeChatMiniProgram, isIos } = window.magicApp?.env || {};
  if (isBaseApp) {
    atom.invoke('launch3rdApp', {
      pkgName: 'com.tencent.mm',
      pkgUrl: isIos ? 'weixin://' : '',
      appName: '微信',
    });
  } else if (!isWeChat && !isWeChatMiniProgram) {
    location.href = 'weixin://';
  }
};

// 从当前url或cookie中获取p_和o_开头的参数，透传到下一页
export const getTVTransparentParams = (targetUrl) => {
  const searchParams = getSearchObj();
  let oParams = JSON.parse(cookie.get('_private_magic_o_params') || '{}');
  let pParams = { ...pParams, ...JSON.parse(sessionStorage.getItem('_private_magic_p_params') || '{}') };
  console.log('transparent params', oParams, pParams);

  // 存入的这些参数直接是直接从URL上取的，会有未decodeURIComponent的情况，这里统一解码一下，防止跳转到其它页面时，参数被多次编码
  oParams = decodeObj(oParams);
  pParams = decodeObj(pParams);

  const extraParams = {};
  // 跳转页是否是魔方活动页
  const isMagicPage = location.hostname.endsWith('qq.com')
  && /\/magic-act\/\d+/.test(new URL(fixUrl(targetUrl)).pathname);
  const transTVLogin = searchParams.tv_login_trans;
  if (isMagicPage && transTVLogin) {
    // 跳转页是魔方活动页时，把o_和p_开头的参数名前缀还原和tv_login_flag一起传到后端传递登录态到下一页面
    // 非魔方活动页，把o_和p_开头的参数去掉前缀，传递到下一页
    const setKeyPrefix = (prefix, obj) => Object.keys(obj).reduce((newobj, key) => (
      { ...newobj, [`${prefix}${key}`]: obj[key] }), {});
    oParams = setKeyPrefix('o_', oParams);
    pParams = setKeyPrefix('p_', pParams);
    extraParams.tv_login_trans = 1;
    extraParams.tv_login_flag = 1;
  }
  return { ...oParams, ...pParams, ...extraParams };
};

const isTVH5Page = () => location.href.includes('tv_login_flag=1');

const useTVTransparentParams = (targetUrl) => {
  const blackList = [
    '/h5/vplus/pay',
  ];
  const u = new URL(validateUrl(targetUrl));
  if (!u.hostname.endsWith('qq.com')) return false;
  return !blackList.find(u => targetUrl.includes(u));
};

const addTransparentParams = (targetUrl) => {
  let params = {};
  if (isTVH5Page() && useTVTransparentParams(targetUrl)) {
    params = getTVTransparentParams(targetUrl);
  }
  return urlUtil.buildUrl(targetUrl, params, true);
};

const openInWeapp = (config) => {
  // 拉起小程序
  const { isBaseApp, isWeChatMiniProgram } = window.magicApp?.env || {};
  const params = {
    userName: config.userName,
    path: config.path,
    miniprogramType: 0,
  };
  if (isWeChatMiniProgram) {
    // 如果是微信小程序内，则直接调用微信JSAPI跳转页面
    // 使用绝对路径
    const url = params.path.startsWith('/') ? params.path : `/${params.path}`;
    return window.wx?.miniProgram.navigateTo({ url });
  }
  // 腾讯视频APP内直接调用JSAPI拉小程序
  isBaseApp && atom.invoke('launchMiniProgram', params);
  // 非腾讯视频APP环境，拉起APP调用JSAPI拉小程序
  !isBaseApp && atom.openUrl(urlUtil.buildUrl('https://film.qq.com/h5/app/openapp.html', {
    appid: params.userName,
    openurl: encodeURIComponent(params.path),
    type: 'miniapp',
  }));
};

const getLiveUrl = (pid, { forceOpenApp } = {}) => {
  const { isApp } = window.magicApp?.env || {};
  if (forceOpenApp || isApp) {
    return `txvideo://v.qq.com/TencentLiveActivity?pid=${pid}`;
  }
  return `https://m.v.qq.com/pgm/${pid}`;
};

const getVideoUrl = (cid = '', vid = '', { forceOpenApp } = {}) => {
  const { isApp } = window.magicApp?.env || {};
  if (forceOpenApp || isApp) {
    return `txvideo://v.qq.com/VideoDetailActivity?vid=${vid || ''}&cid=${cid || ''}`;
  }
  return urlUtil.buildUrl('https://m.v.qq.com/x/play.html', { cid, vid }, true);
};

const validateUrl = (url) => {
  if (!/^(http:|https:|\/\/|txvideo)/.test(url)) {
    const a = document.createElement('A');
    a.href = url;
    url = a.href;
  }
  return fixUrl(url);
};

const useRedirectPage = (redirectPage) => {
  redirectPage = redirectPage || 'https://m.v.qq.com/activity/downapp_activity.html?not_auto_open=0&schema=${encodedSchemeUrl}';
  // eslint-disable-next-line no-new-func
  return new Function('encodedSchemeUrl', `return \`${redirectPage}\``);
};

const transformToScheme = (url) => {
  if (url.startsWith('http')) {
    return `tenvideo2://?action=10&openurl=${encodeURIComponent(url)}&newtenvideo2=1`;
  }
  return url;
};

const isSchemaUrl = url => url && url.match(/^(txvideo|tenvideo)/);

const parseCidVid = (url, type) => {
  if (!url) return '';

  try {
    const u = new URL(url).searchParams;
    if (type === 'cid') return u.get('cid') || u.get('cover_id') || '';
    if (type === 'vid') return u.get('vid') || u.get('video_id') || '';
  } catch (e) {
    return '';
  }
};

export const openUrl = async function (url = '', {
  forceOpenApp = false,
  openType,
  cid = parseCidVid(url, 'cid'), vid = parseCidVid(url, 'vid'), pid = '',
  extraParams = {},
  openInNewWindow,
  ...rest
} = {}) {
  const { isApp, isWeChatMiniProgram, isMqq, isWetv } = window.magicApp?.env || {};

  if (!forceOpenApp) {
  // 在各个端中打开视频播放
    if (await mqbHandler({ cid, vid })) return;

    if (await qqnewsHandler({ cid, vid })) return;

    if (await weishiHandler({ cid, vid })) return;

    if (await qqmusicHandler({ cid, vid })) return;

    if (await sportsHandler({ cid, vid })) return;

    if (yybHandler(url)) return;

    if (tenvideoPcHandler({
      url,
      openInNewWindow,
    })) return;

    if (isMqq && (cid || vid)) {
      const path = urlUtil.buildUrl('preload_play/play/index', { cid, vid });
      if (window.qq) {
        // 如果本来就在小程序中，直接跳转到对应页面
        return window.qq.miniProgram.navigateTo({ url: path });
      }
      return window.mqq.invoke('miniApp', 'openApp', {
        appid: '1109840991', // 必填，小程序appid， string
        via: '2014_71', // 必填，场景来源值，用于统计
        path, // 选填，指定打开小程序的page
      });
    }

    if (isWetv && (cid || vid)) {
      return atom.invoke('openView', {
        url: `tenvideoi18n://wetv/videodetail?cid=${cid}&vid=${vid}`,
        close: '0',
      });
    }

    // 在小程序中打开
    // 默认跳转小程序页面，带有 cid vid 时，直接跳转小程序播放页
    if (isWeChatMiniProgram && !url.includes('http') && !url.includes('//')) {
      openType = openType || 'weapp';
      rest.path = rest.path || url;
      rest.userName = rest.userName || 'gh_fce17bb0518f';
      if (cid || vid) {
        rest.path = rest.path || `preload_play/play/index?cid=${cid}&vid=${vid}`;
      }
    }
  }

  if (this?.app?.pages?.[0].envName === 'tv' || this?.pages?.[0]?.envName === 'tv' || window.magicApp?.env.isTv) {
    // TV 环境
    return tvHandler(url);
  }

  if (openType === 'weapp') {
    return openInWeapp(rest);
  }
  if (openType === 'wechat') {
    return openWechat();
  }

  if (openType === 'tenSports') {
    return qqsportsHandler(url);
  }

  // 根据cid, vid, pid生成对应的地址
  if (!url) {
    if (pid) {
      url = getLiveUrl(pid, { forceOpenApp });
    } else if (cid || vid) {
      url = getVideoUrl(cid, vid, { forceOpenApp });
    }
  }

  // 格式化url
  url = validateUrl(url);

  url = urlUtil.buildUrl(url, extraParams, true);

  url = addTransparentParams(url);

  // APP外拉APP，需要检验账号一致性时，添加账号一致性相关的参数
  if (
    !isApp
    && (isSchemaUrl(url) || forceOpenApp)
    && getPageConfig().checkAccount === 'app') {
    await accountCheck.check(getPageConfig().checkAccountConfig);
    const authParams = accountCheck.getParams(!isSchemaUrl(url));
    console.log(authParams);
    url = urlUtil.buildUrl(url, authParams, true);
  }

  // 强制拉APP，把http地址转为scheme链接
  if (forceOpenApp) {
    url = transformToScheme(url);
  }

  // 非app环境，跳转scheme地址，需要使用中间页时，转为中间页地址
  if (
    getPageConfig().useRedirectPage
    && isSchemaUrl(url)
    && !window.magicApp?.env?.isApp
  ) {
    // 使用中间页拉起
    url = useRedirectPage(getPageConfig().redirectPage)(encodeURIComponent(url));
  }

  // scheme地址跳转，APP外拉起
  if (isSchemaUrl(url) && !window.magicApp?.env?.isApp) {
    return openInApp(url);
  }

  if (getUrlParam('is_prepublish')) {
    const tmpUrl = new URL(url);
    tmpUrl.searchParams.set('is_prepublish', getUrlParam('is_prepublish'));
    url = tmpUrl.toString();
  }

  if (!isApp && /^https?:/.test(url) && openInNewWindow) {
    window.open(url);
    return;
  }

  // 腾讯视频全平台通用的跳转
  atom.openUrl(url);
};

const supportComponentConfig = componentType => ['page'].includes(componentType);

export default {

  name: '@tencent/magic-ui-plugin-act-openurl',

  processFormConfig(type, config) {
    if (!supportComponentConfig(type)) {
      return config;
    }

    const tab = config.find(item => item.type === 'tab') || { items: [] };
    tab.items.push({
      title: 'URL插件',
      labelWidth: '100px',
      items: generateFormConfig(),
    });
    return config;
  },

  install(Vue) {
    Vue.mixin({
      created() {
        const isApp = this.$options.name === 'magic-ui' && this.pageConfig;
        if (isApp) {
          magicUiApp = this;
        } else {
          return;
        }
        const needCheck = getUrlParam('o.vuserid');
        needCheck && login.init(() => {
          accountCheck.check(getPageConfig().checkAccountConfig || {});
        });
      },
    });
    Vue.prototype.$magicOpenUrl = openUrl;
  },
};
